module.exports = "/images/bbva.svg?a2f08cf107a90b37ec5d4b14d8fdbf52";